/**
 * Plan Types section displaying insurance category cards.
 *
 * Renders a responsive grid of plan type cards, each with a stock image,
 * title, and description. All text is sourced from the `landing` i18n
 * namespace. Data-driven via the {@link PLAN_TYPES} array.
 *
 * @module landing/sections/PlanTypesSection
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ResponsiveContainer } from '../../../shared/src/responsive/ResponsiveContainer';
import { ResponsiveGrid } from '../../../shared/src/responsive/ResponsiveGrid';
import { SectionHeading } from '../components/SectionHeading';
import { ImagePlaceholder } from '../components/ImagePlaceholder';
import { PLAN_TYPES } from '../content/plan-types';
import { LANDING_IMAGES } from '../content/images';

/**
 * Plan Types section with a grid of insurance category cards.
 */
export function PlanTypesSection(): React.JSX.Element {
  const { t } = useTranslation('landing');

  return (
    <ResponsiveContainer>
      <SectionHeading
        title={t('planTypes.heading')}
        subtitle={t('planTypes.subheading')}
      />
      <ResponsiveGrid sm={2} lg={4}>
        {PLAN_TYPES.map((item) => (
          <div key={item.id} className="ipa-card">
            <ImagePlaceholder
              src={LANDING_IMAGES[item.imageKey]}
              alt={t(`planTypes.${item.i18nKey}.title`)}
            />
            <div className="ipa-card__header">
              <h3 className="ipa-card__title">
                {t(`planTypes.${item.i18nKey}.title`)}
              </h3>
            </div>
            <p className="landing-plan-card__description">
              {t(`planTypes.${item.i18nKey}.description`)}
            </p>
          </div>
        ))}
      </ResponsiveGrid>
    </ResponsiveContainer>
  );
}
